import { productIdFormat, supplierIdFormat } from "@redotech/redo-model/ids";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const forecastingNumericFieldType = createEnum([
  "moq",
  "leadTime",
  "buffer",
  "coverageDays",
]);
export type ForecastingNumericFieldType = z.infer<
  typeof forecastingNumericFieldType
>;

export const forecastingFieldType = createEnum([
  "moq",
  "leadTime",
  "buffer",
  "coverageDays",
  "supplier",
]);
export type ForecastingFieldType = z.infer<typeof forecastingFieldType>;

export const bulkUpdateForecastingFields = {
  name: "bulkUpdateForecastingFields" as const,
  input: z.object({
    productIds: z.array(productIdFormat.schema),
    field: forecastingFieldType,
    numericValue: z.number().int().min(0).optional(),
    supplierId: supplierIdFormat.schema.nullish(),
  }),
  output: z.object({
    updatedCount: z.number().int(),
  }),
};
